import PropTypes from 'prop-types';
import React, { Component } from 'react';

import Scrolling from '../../navigation/scrolling';
import { moveButtons } from '../../navigation/scrolling/helpers';
import * as ST from './styled';

class Tabs extends Component {
    static propTypes = {
        activeTab: PropTypes.any,
        children: PropTypes.array,
        label: PropTypes.string,
        onSwitchTab: PropTypes.func,
        withSSR: PropTypes.bool,
    };

    static defaultProps = {
        onSwitchTab: () => { },
    };

    constructor(props) {
        super(props);

        let currentTab = props.activeTab || false;
        if (props.children) {
            const children = Array.isArray(props.children) ? props.children : [props.children];
            currentTab = currentTab ? currentTab : children[0].props.label;
        }

        this.state = {
            currentTab: currentTab,
            barStyles: {},
            hasScroll: false,
        };

        this.headerRef = React.createRef();
        this.activeTab = React.createRef();
    }

    getStyles = () => (this.activeTab.current
        ? {
            width: this.activeTab.current.clientWidth,
            left: this.activeTab.current.offsetLeft,
        }
        : {}
    );

    componentDidMount() {
        this.findActiveTab();
        this.setState({
            barStyles: this.getStyles(),
        });

        const scrollingListRef = this.scrolling.scrollingListRef.current;
        if (scrollingListRef) {
            scrollingListRef.style.height = '100%';
        }
    }

    findActiveTab = () => {
        const { children } = this.props;
        const { currentTab } = this.state;
        let childrenArray = [];
        if (children) {
            childrenArray = Array.isArray(children) ? children : [children];
        }
        // если активная вкладка теперь скрыта
        let activeHeaderItem = currentTab;
        childrenArray.forEach(tab => {
            if (tab && tab.props.label == currentTab && tab.props.hidden) {
                activeHeaderItem = childrenArray.find(item => !item.props.hidden).props.label;
            }
        });
        if (activeHeaderItem != currentTab) {
            this.setState({
                currentTab: activeHeaderItem,
            });
            return true;
        }
        return false;
    }

    componentDidUpdate(prevProps) {
        const { activeTab, justify } = this.props;
        const { barStyles } = this.state;

        // если активная вкладка скрыта - найти нескрытую
        if (this.findActiveTab()) {
            return;
        }

        const scrollingList = this.scrolling?.scrollingListRef?.current;

        if (scrollingList && justify) {
            scrollingList.style.justifyContent = 'space-between';
        }

        const style = this.getStyles();

        if (JSON.stringify(barStyles) !== JSON.stringify(style)) {
            this.setState({
                barStyles: style,
            });
        }

        if (activeTab !== prevProps.activeTab) {
            this.setState({
                currentTab: activeTab,
            });
        }
    }

    switchTab = (e, tabLabel) => {
        const [rects] = e.target.getClientRects();

        const headerWith = this.headerRef.current.offsetWidth;
        const tabOffset = rects.left + rects.width;
        const headersScrollLeft = this.headerRef.current.scrollLeft;

        moveButtons(e, this.scrolling);

        if (tabOffset > headerWith) {
            this.headerRef.current.scrollLeft = rects.left;
        }

        if (rects.left < 0) {
            this.headerRef.current.scrollLeft = headersScrollLeft - Math.abs(rects.left);
        }

        this.setState({ currentTab: tabLabel });
        if (this.props.onSwitchTab) {
            this.props.onSwitchTab(tabLabel);
        }
    };

    renderHeaders = () => {
        const { children, accentColor, withSSR } = this.props;

        let content = null;

        const headers = React.Children.map(children, (tab, idx) => {
            if (!tab || tab.hidden) {
                return;
            }
            const { label, badge, ...props } = tab.props;
            const { currentTab } = this.state;

            const isCurrentTab = label === currentTab;

            if (!withSSR && isCurrentTab) {
                content = tab;
            }

            return (
                <ST.TabsItem
                    key={idx}
                    active={isCurrentTab}
                    accentColor={accentColor}
                    onClick={(e) => this.switchTab(e, label)}
                    ref={isCurrentTab ? this.activeTab : null}
                    {...props}
                >
                    {label}
                    {badge !== undefined ? <ST.Badge>{badge}</ST.Badge> : null}
                </ST.TabsItem>
            );
        });
        if (withSSR) {
            content = React.Children.map(children, (tab, index) => (
                tab && tab.props.label === this.state.currentTab
                    ? <div key={index}>{tab}</div>
                    : <ST.HiddenTab key={index}>{tab}</ST.HiddenTab>
            ));
        }
        return { headers, content };
    };

    render() {
        const { headers, content } = this.renderHeaders();
        const { accentColor, className } = this.props;

        return (
            <ST.TabsWrapper className={className}>
                <ST.TabsHead>
                    <ST.TabsHeader ref={this.headerRef}>
                        <Scrolling ref={scrolling => this.scrolling = scrolling}>
                            <ST.Bar
                                style={this.state.barStyles}
                                accentColor={accentColor}
                                hasScroll={this.state.hasScroll}
                            />
                            {headers}
                        </Scrolling>
                    </ST.TabsHeader>
                </ST.TabsHead>
                {content}
            </ST.TabsWrapper>
        );
    }
}

export default Tabs;
